/**
 * Page is only accessible if user is authenticated.
 */

import AppApi from '@api/AppApi';
import { setupRoute } from '@utils/SetupUtil';

function routeAfterAuth(to, from, user, project) {
    // Sub-accounts never use the wizard — pick or wait for an assigned project.
    if (to.name === 'setup' && user?.is_sub_account) {
        return project ? { name: 'dashboard' } : { name: 'select-project' };
    }

    // Sub-accounts with no selected project must choose one (or see the empty state).
    if (user?.is_sub_account && !project && to.name !== 'select-project') {
        return { name: 'select-project' };
    }

    // Already have a project — no need to stay on the picker.
    if (to.name === 'select-project' && project) {
        return { name: 'dashboard' };
    }

    // No project, or first-project wizard not finished. Stay on project setup.
    if (to.name !== 'setup' && to.name !== 'select-project' && user && !user.is_sub_account && (!project || !project.setup_completed_at)) {
        return setupRoute({ from, to });
    }

    return null;
}

export default function({ to, from, store }) {
    // Get vars.
    let apiKey = store.getters.apiKey;
    let user = store.getters.user;
    let project = store.getters.project;

    // Not authenticated. Redirect to login page.
    if (to.name !== 'login' && !apiKey) {
        return { name: 'login', query: { redirect: to.fullPath } };
    }

    if (user) {
        const redirect = routeAfterAuth(to, from, user, project);
        if (redirect) {
            return redirect;
        }
    }

    // No user. Boot app and redirect.
    if (!user) {
        return AppApi.getApp().then(() => {
            const bootedUser = store.getters.user;
            const bootedProject = store.getters.project;
            const redirect = routeAfterAuth(to, from, bootedUser, bootedProject);
            if (redirect) {
                return redirect;
            }
            return to;
        }, (error) => {
            if (error?.response?.data?.message === 'mfa.required') {
                return { name: 'mfa' };
            }
            console.error('Error booting the app:', error);
            // This should not fail, but redirect to login if it does.
            store.commit('logout');
            return { name: 'login' };
        });
    }
}
